import { Routes } from '@angular/router';


export  const  chatwithExpertroutes: Routes = [{
  path: '', loadComponent: () => import('./live-chat-home/live-chat-home.component').then(m => m.LiveChatHomeComponent),
  children: [
    {
      path: 'chatWithExpert', // Child route (parent/a)
      loadComponent: () => import('./login-question-one/login-question-one.component').then(m => m.LoginQuestionOneComponent)
    },
    {
      path: 'generalQuestions',
      loadComponent: () => import('./general-questions/general-questions.component').then(m => m.GeneralQuestionsComponent)
    },
    {
      path: 'accountRelatedQuestions',
      loadComponent: () => import('./account-related-question/account-related-question.component').then(m => m.AccountRelatedQuestionComponent)
    },
    {
      path: 'regularLogin',
      loadComponent: () => import('./regular-login/regular-login.component').then(m => m.RegularLoginComponent)
    },
    {
      path: 'agentWindow',
      loadComponent: () => import('./agent-window/agent-window.component').then(m => m.AgentWindowComponent)
    },
    {
      path: 'verifyLogin',
      loadComponent: () => import('./login-with-verify/login-with-verify.component').then(m => m.LoginWithVerifyComponent)
    }
  ]

},];




